export const signIn = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signInWithEmailAndPassword(creds.email, creds.password)
      .then(() => {
        dispatch({ type: "SIGN_IN" });
      })
      .catch((err) => {
        dispatch({ type: "SIGN_IN_ERR" }, err);
      });
  };
};

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch({ type: "SIGN_OUT" });
      });
  };
};

export const signUp = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    // TODOs ? işaretli çözüm için daha iyi bir yol olup olmadığını araştır.
    const fullName = `${creds.firstName} ${creds.middleName} ${creds.lastName}`;
    firebase
      .auth()
      .createUserWithEmailAndPassword(creds.email, creds.password)
      .then((regUser) => {
        regUser.user.updateProfile({
          displayName: fullName,
        });
      })
      .then(() => {
        dispatch({ type: "SIGN_UP" });
      })
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        alert(err);
        // dispatch({ type: "SIGN_UP_ERR" }, err);
      });
  };
};

export const memberSignUp = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    // const authorId = getState().firebase.auth.uid;
    const db = getFirebase().firestore();
    // TODOs ? işaretli çözüm için daha iyi bir yol olup olmadığını araştır.
    // const fullName = `${creds.firstName} ${creds.middleName} ${creds.lastName}`;
    firebase
      .auth()
      .createUserWithEmailAndPassword(creds.email, creds.password)
      // .then((regUser) => {
      //   regUser.user.updateProfile({
      //     emailVerified: true,
      //   });
      // })
      .then((regUser) => {
        db.collection("profile").doc(regUser.user.uid).set({
          authorId: regUser.user.uid,
          date: new Date(),
        });
      })
      .then(() => {
        dispatch({ type: "SIGN_UP" });
      })
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        alert(err);
        // dispatch({ type: "SIGN_UP_ERR" }, err);
      });
  };
};

export const resetPassword = (email) => {
  return (dispatch, getState, { getFirebase }) => {
    const alertify = require("alertifyjs");
    const firebase = getFirebase();
    // TODOs ? işaretli çözüm için daha iyi bir yol olup olmadığını araştır.
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        alertify.alert(
          "Reset Password",
          "Email sent successfully, please check your email address.",
          function () {
            window.location.href = "/signin";
          }
        );
      })
      .catch((err) => {
        alertify.error(`${err}`);
      });
  };
};

export const verifyMember = (fullName) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    const user = firebase.auth().currentUser;

    user
      .updateProfile({
        displayName: fullName.slice(0, -1),
        // photoURL: "0",
      })
      .then(() => {
        dispatch({ type: "VERIFY_TEST" });
      })
      // .then(() => {
      //   window.location.reload();
      // })
      .catch((err) => {
        dispatch({ type: "VERIFY_TEST_ERR" }, err);
      });
  };
};

// TODOs geçici klasöründe kullanılıyor. Değiştirilecek
export const signInMember = (creds) => {
  const alertify = require("alertifyjs");
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signInWithEmailAndPassword(creds.email, "123456789")
      .then(() => {
        alertify
          .alert("Info", "User Activated!")
          .set("onok", function (closeEvent) {
            const user = firebase.auth().currentUser;

            user
              .updateProfile({
                displayName: "not-verify",
              })
              .catch((err) => {
                alertify.error("" + err);
              });
          });
      })
      .catch((err) => {
        alertify.error("" + err);
      });
  };
};
